<!-- eslint-disable max-lines -->
<template>
    <div class="customer-visit-manage">
        <Paper class="customer-visit-manage-paper">
            <el-tabs
                class="customer-visit-list-tab-pane"
                v-model="activeTabs">
                <!-- 重点客户分级管理 -->
                <el-tab-pane
                    label="重点客户分级管理"
                    name="theList"
                    ref="myPane"
                    v-loading="holePageLoading">
                    <list-layout-paper>
                        <template slot="header-search">
                            <search-box
                                ref="searchBox"
                                :search-key="config.name"
                                :fields="config.searchFields"
                                :showResetBtn="true"
                                @search-change="getListClass.searchList"
                            />
                        </template>
                        <template slot="header-button">
                            <lotsButton v-has="authorityCode.import" icon="el-icon-upload2" type="primary" size="mini" title="导入"
                                class="bigData-btn-customer-visit-list-import"
                                @click="openImport">导入
                            </lotsButton>
                            <lotsButton v-has="authorityCode.useBatch" icon="el-icon-upload2" type="primary" size="mini" title="批量启用任务"
                               class="bigData-btn-customer-visit-list-batch-enable"
                               :disabled="!getListClass.selectedRows.length" @click="batchChangeStatusHandle">批量启用任务
                            </lotsButton>
                            <lotsButton v-has="authorityCode.delete" icon="el-icon-delete" type="primary" size="mini" title="删除任务"
                                 class="bigData-btn-customer-visit-list-delete"
                                 :disabled="!getListClass.selectedRows.length" @click="deleteRaskHandle">删除任务
                            </lotsButton>
                            <lotsButton
                                v-has="authorityCode.export"
                                type="primary"
                                size="mini"
                                icon="el-icon-download"
                                class="bigData-btn-customer-visit-list-export"
                                @click="handleExport()"
                                title="导出">
                                导出
                            </lotsButton>
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="刷新"
                                @click="refresh"
                                plain>
                                <span class="icon iconfont icon-refresh"></span>
                            </lotsButton>
                            <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                                <el-button
                                icon="iconfont icon-list_install"
                                type="primary"
                                size="mini"
                                :title="'列配置'"
                                @click="showColumnConfigDialog"
                                plain />
                            </el-tooltip>
                        </template>
                        <!-- 表格 -->
                        <template v-slot:list="{ tableHeight }">
                            <table-box ref="customerVisitManageRef" :tableID="config.name" :height="tableHeight" :control="true"
                                v-loading="getListClass.tableLoading" :selection="config.selection" :index="config.index"
                                :columns="config.columns" :rows="getListClass.totalData" :actions="config.actions"  :allowRowClick="false"
                                @action-click="actionClick" @selection-change="getListClass.handleSelectedRow" :selectable="selectable"
                            >
                            <template v-slot:col-append="{ col, row }">
                                <div class="mip-link"  @click="toFlowLinkHandle(row)">{{ row.fdId ? '查看流程流转记录' : ''}}</div>
                            </template>
                        </table-box>
                        </template>
                        <template slot="footer">
                            <lots-pagination
                                @size-change="getListClass.sizeChange"
                                :current-page.sync="getListClass.pageNo"
                                @current-change="getListClass.pageChange"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="getListClass.pageTotal" >
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                </el-tab-pane>
            </el-tabs>
            <!-- 表格列配置弹框 -->
            <column-config
                :pageID="config.name"
                :initColumns="config.columns"
                ref="otpColumnConfig"
                @header-change="config.columns = $event"
            />

            <!-- 导入弹窗 -->
           <addFileDialog ref="fileDialogRef" :config="config.importConfig" @uploadSuccessHandle="uploadSuccessHandle"
                @uploadFailHandle="uploadFailHandle">
                <template slot="btnSlot">
                    <lotsButton type="primary" :loading="downTemplateLoading" size="mini" @click="handleDownTemplate">下载模版
                    </lotsButton>
                </template>
            </addFileDialog>
            <customerVisitDialog ref="customerVisitDialogRef" @confirm-update="handleConfirmUpdate" />
            <deleteReasonDialog ref="deleteReasonDialogRef" @confirm-update="handleConfirmUpdate" />
        </Paper>
    </div>
</template>
<script>
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import tableBox from '@/components/lots/tableBox/Index';
import { getcustomerVisitListApi, visitTemplateDownloadApi, getListExportApi, batchEnableApi } from '@mdm/api/customer/customerVisitManage.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic } from './config';
import { ref, reactive, onMounted, getCurrentInstance } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import store from '@/store';
import utils from '@/components/utils/common.js';
import lotsButton from '@/components/lots/lotsButton';
import columnConfig from '@/components/lots/columnConfig/Index';
import _ from 'lodash';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import customerVisitDialog from './customerVisitDialog/Index.vue';
import deleteReasonDialog from './components/deleteReasonDialog/Index.vue';

export default {
    name: 'customerVisitManage',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        tableBox,
        lotsPagination,
        lotsButton,
        columnConfig,
        addFileDialog,
        customerVisitDialog,
        deleteReasonDialog
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance();
        const dictDatas = ref({});
        onMounted(async() => {
            const dictKeys = [
                'CUSTOMER_VISIT_INFO_STATUS'
            ];
            dictDatas.value = await otherUtils.getDictDataList(config.columns, dictKeys);
            setupContext.refs.searchBox.submitSearch();
        });

        // 列表类配置
        const config = reactive(configStatic);
        // 列表类-全局loading
        const holePageLoading = ref(false);
        // 列表列配置弹窗
        const otpColumnConfig = ref(null);
        // 列表列配置弹窗-打开
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };
        // 列表列配置弹窗-当前选中的tab
        const activeTabs = ref('theList');

        // 列表类
        class ListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (res && +res.code === 0) {
                    this.totalData.value = res.data.list.map(it => {
                        it.contactMobileCn = [null, undefined, ''].includes(it.contactMobile) ? it.contactMobile : '***';
                        it.contactCn = [null, undefined, ''].includes(it.contact) ? it.contact : '***';
                        return it;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }

        // 列表类-实例化
        const getListClass = new ListClass({
            Api: {
                listApi: getcustomerVisitListApi
            }
        });
        // 列表类-查询参数格式化
        const searchDataFormat = (condition) => {
            if (condition.visitTimeStart && condition.visitTimeStart.length) {
                condition.visitTimeStartFrom = utils.formatDateTime(condition.visitTimeStart[0]);
                condition.visitTimeStartTo = utils.formatDateTime(condition.visitTimeStart[1]);
                Reflect.deleteProperty(condition, 'visitTimeStart');
            }
            if (condition.visitTimeEnd && condition.visitTimeEnd.length) {
                condition.visitTimeEndFrom = utils.formatDateTime(condition.visitTimeEnd[0]);
                condition.visitTimeEndTo = utils.formatDateTime(condition.visitTimeEnd[1]);
                Reflect.deleteProperty(condition, 'visitTimeEnd');
            }

            Object.keys(condition).forEach(k => {
                const v = condition[k];
                if (v === '' || v === null || (Array.isArray(v) && v.length === 0)) {
                    delete condition[k];
                }
            });
            condition.orderBy = 'create_time';
            condition.orderByType = 'desc';
            return condition;
        };

        // 刷新列表
        const refresh = () => {
            getListClass.getList();
        };

        // 按钮权限
        const authorityCode = reactive(btnAuthority.customerVisitManage);

        // 打开导入弹窗
        const openImport = () => {
            config.importConfig.beforeRequest = (params) => {
                params.roleType = 1;
                return params;
            };
            setupContext.refs.fileDialogRef.openImport();
        };
        const uploadSuccessHandle = () => {
            getListClass.getList();
        };
        const uploadFailHandle = () => {
            getListClass.getList();
        };
        // 列表单个数据操作点击事件
        const actionClick = (event, row, index) => {
            // 编辑的时候需要回显对应的数据类型下拉
            switch (event) {
            case 'edit':
                openDialogHandle(row, event);
                break;
            case 'look':
                openDialogHandle(row, event);
                break;
            }
        };
        const openDialogHandle = (row, type) => {
            setupContext.refs.customerVisitDialogRef.show(row, type === 'edit');
        };

        // 下载文件
        const downLoadFile = (row) => {
            window.open(row.fileUrl);
        };

        // 导出列表信息
        const handleExport = async () => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const _columns = config.columns?.filter(it => !['contactCn', 'contactMobileCn', 'fdId'].includes(it.prop));
            const excelTitleList = _columns?.filter(item => (!item.hiddenColumn)).map(item => ({
                name: item.label,
                property: item.prop
            })) ?? [];
            const { value } = getListClass.searchModel;
            const newData = _.cloneDeep(searchDataFormat(value)); // 解决搜索参数被清空的问题
            Object.keys(newData).forEach(v => {
                if (newData[v] === undefined || newData[v] === null || newData[v] === '') {
                    delete newData[v];
                }
            });
            // 配置了那些字段就传那些
            newData.excelTitleList = excelTitleList;
            getListExportApi(newData).then(res => {
                if (+res.code === 0) {
                    Message.success('请稍后到右上角用户文件列表中下载');
                }
            });
        };

        const batchChangeStatusHandle = () => {
            // 检查是否至少选择了一行
            const selectList = getListClass.selectedRows.value;
            if (!selectList.length) {
                Message.warning('请至少选择一行数据!');
                return;
            }

            // 获取当前登录用户的编码
            const userCode = store.getters.user.userCode;

            // 校验选中的数据中不等于未启动状态的任务
            const notStartedTasks = selectList.filter(item => item.statusCode !== 'draft');

            if (notStartedTasks.length > 0) {
                const taskInfoList = notStartedTasks.map(task => {
                    const taskName = task.billTitle || task.billCode || '未知任务';
                    const statusName = dictDatas.value['CUSTOMER_VISIT_INFO_STATUS']?.[task.statusCode] || `状态${task.statusCode}`;
                    return `任务名称: ${taskName}, 任务状态: ${statusName}`;
                });

                const errorMessage = `以下任务状态不是未启动，无法批量启用：<br />${taskInfoList.join('<br />')}`;
                Message.warning({
                    message: errorMessage,
                    dangerouslyUseHTMLString: true
                });
                return;
            }

            // 校验创建人是否等于当前登录用户
            const notCreatorTasks = selectList.filter(item => item.createUserCode !== userCode);

            if (notCreatorTasks.length > 0) {
                const customerNames = notCreatorTasks.map(task => task.customerName || '未知客户').join('<br />');
                const errorMessage = `以下客户创建人不是当前登录人，不允许启用：<br />${customerNames}`;
                Message.warning({
                    message: errorMessage,
                    dangerouslyUseHTMLString: true
                });
                return;
            }

            // 如果校验通过，显示二次确认弹窗
            const customerNames = selectList.map(item => item.customerName || '未知客户').join('<br />');
            const confirmHtml = `<div style="max-height: 300px; overflow-y: auto;">确认要批量启用以下客户的任务吗？<br /><br />${customerNames}</div>`;

            MessageBox.confirm(confirmHtml, '批量启用', {
                confirmButtonText: '确认启用',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                customClass: 'batch-enable-msg-box',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.cancelButtonDisabled = true;

                        const params = {
                            ids: getListClass.selectedRows.value.map(it => it.id)
                        };

                        batchEnableApi(params).then(res => {
                            if (res && +res.code === 0) {
                                instance.confirmButtonLoading = false;
                                instance.cancelButtonDisabled = false;
                                done();
                                getListClass.getList();
                                setTimeout(() => {
                                    setOpenDialogMessage(res.data);
                                }, 0);
                            } else {
                                instance.confirmButtonLoading = false;
                                instance.cancelButtonDisabled = false;
                            }
                        }).catch(err => {
                            Message.error(err?.message || '启用失败，请重试');
                            instance.confirmButtonLoading = false;
                            instance.cancelButtonDisabled = false;
                        });
                    } else {
                        done();
                    }
                }
            });
        };
        const setOpenDialogMessage = (data) => {
            if (!Array.isArray(data) || data.length === 0) {
                return;
            }
            const successList = data.filter(item => item.success);
            const failList = data.filter(item => !item.success);

            if (failList.length === 0) {
                Message.success(`下发成功${successList.length}条`);
            } else {
                const failMsg = failList.map(item => _.get(item, 'customerName', '') + _.get(item, 'msg', '')).join('<br />');
                MessageBox.alert(
                    `下发成功${successList.length}条，下发失败${failList.length}条<br /><br />${failMsg}`,
                    '下发结果',
                    {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        dangerouslyUseHTMLString: true,
                        customClass: 'visit-manage-msg-box'
                    }
                );
            }
        };
        const downTemplateLoading = ref(false);
        const handleDownTemplate = () => {
            const params = {
                fileName: '客户拜访信息-导入模版.xlsx'
            };
            downTemplateLoading.value = true;
            visitTemplateDownloadApi(params).then(res => {
                try {
                    return JSON.parse(res); // 是 JSON 对象
                } catch (e) {
                    Message.success('下载成功');
                }
                downTemplateLoading.value = false;
            }).finally(() => {
                downTemplateLoading.value = false;
            });
        };
        const selectable = (row, index) => {
            return ['draft'].includes(row.statusCode);
        };

        // 删除任务方法
        const deleteRaskHandle = () => {
            const selectList = getListClass.selectedRows.value;
            if (!selectList.length) {
                Message.warning('请至少选择一行数据!');
                return;
            }

            const nonDraftTasks = selectList.filter(item => !['draft'].includes(item.statusCode));

            if (nonDraftTasks.length > 0) {
                const taskInfoList = nonDraftTasks.map(task => {
                    const customerName = task.customerName || '未知客户';
                    const statusName = dictDatas.value['CUSTOMER_VISIT_INFO_STATUS']?.[task.statusCode] || `状态${task.statusCode}`;
                    return `客户名称: ${customerName}, 任务状态: ${statusName}`;
                });

                const errorMessage = `以下任务状态不是未下发，不允许删除：<br />${taskInfoList.join('<br />')}`;
                Message.warning({
                    message: errorMessage,
                    dangerouslyUseHTMLString: true
                });
                return;
            }

            const userCode = store.getters.user.userCode;
            const notCreatorTasks = selectList.filter(item => item.createUserCode !== userCode);

            if (notCreatorTasks.length > 0) {
                const customerNames = notCreatorTasks.map(task => task.customerName || '未知客户').join('<br />');
                const errorMessage = `以下客户创建人不是当前登录人，不允许删除：<br />${customerNames}`;
                Message.warning({
                    message: errorMessage,
                    dangerouslyUseHTMLString: true
                });
                return;
            }

            setupContext.refs.deleteReasonDialogRef.show(selectList);
        };

        // 处理确认删除（来自删除原因弹窗的回调）
        const handleConfirmUpdate = (result) => {
            getListClass.getList(); // 刷新列表
        };
        const toFlowLinkHandle = (row) => {
            // if (row.fdId) {
            ctx.$router.push('/customerVisitFlow?id=' + row.id);
            // }
        };
        return {
            getListClass,
            config,
            downTemplateLoading,
            holePageLoading,
            utils,
            authorityCode,
            dictDatas,
            otpColumnConfig,
            activeTabs,
            showColumnConfigDialog,
            actionClick,
            handleExport,
            refresh,
            openImport,
            uploadSuccessHandle,
            downLoadFile,
            batchChangeStatusHandle,
            uploadFailHandle,
            handleDownTemplate,
            selectable,
            deleteRaskHandle,
            handleConfirmUpdate,
            toFlowLinkHandle
        };
    }
};
</script>
<style lang="less" >
.visit-manage-msg-box {
    max-height: 440px;
    min-width: 600px;
    .el-message-box__message {
        width: 540px;
        padding: 0 15px;
        max-height: 320px;
        overflow-y: auto;
        line-height: 1.6;
        color: #606266;
    }
}
.batch-enable-msg-box {
    max-height: 440px;
    min-width: 500px;
    .el-message-box__message {
        max-height: 320px;
        overflow-y: auto;
        line-height: 1.6;
        color: #606266;
    }
}
.customer-visit-manage {
    width: 100%;
    .customer-visit-manage-paper {
        height: 100%;
    }
    .list-layout-wrapper {
        height: 100%;
    }
    .customer-visit-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;
        & > .el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;
            & > .el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;
                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }
    .list-header {
        .customer-visit-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }
    .list-layout .list-header .el-input{
        margin-left: 0;
    }
    .layout-content.customer-visit-manage-paper {
        padding: 0px 20px 20px;
        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
}

.column-config_title {
    font-size: 14px;
}

.mip-link{
    color: #4285f5;
    cursor: pointer;
}
</style>
